// Session timeout configuration
// NOTE: This is a temporary fix per pen test finding and LLX requirements
// TODO: Redevelop admin app with better auth that meets short session requirements

// Session timeout in milliseconds
// Currently set to 15 minutes (900000ms)
export const SESSION_TIMEOUT_MS = 60000 * 15; // 15 minutes

// Session check interval in milliseconds (how often to check for expiry)
export const SESSION_CHECK_INTERVAL_MS = 60000; // 1 minute
